import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';

import { completeTask, updateTask, deleteTask } from '../../../../Actions/Dashboard/task';

class Task extends React.Component {
  state = {
    task: '',
    isEdit: false,
  };

  componentDidMount() {
    this.setState({ task: this.props.task.string });
  }

  submit = (e) => {
    e.preventDefault();

    this.props.dispatch(updateTask({
      id: this.props.task.id,
      string: this.state.task,
    }));
    this.setState({ isEdit: false });
  }

  delete = (taskId) => {
    this.props.dispatch(deleteTask(taskId));
  }

  complete = (taskId) => {
    this.props.dispatch(completeTask(taskId));
  }

  render() {
    const { task } = this.props;
    return (
      <li className={`cb-blog_listing_item ${task.pathway}`} key={task.id}>
        <div className="wrap">
          <div className="content">
            <div className="complete">
              {task.status !== 'completed' ?
                <a onClick={() => { this.complete(task.id); }} className="checked">Complete</a> :
                <a className="checked clicked">Completed</a>
              }
            </div>
            <div className="task">
              <div>
                {this.state.isEdit ?
                  <form action="" onSubmit={this.submit}>
                    <textarea
                      onChange={e => this.setState({ task: e.target.value })}
                      placeholder="Your Task"
                      value={this.state.string}
                    />
                    <div className="justifycentre"><input className="button" type="submit" value="Save" /></div>
                  </form>
                : task.string }
              </div>
              <span><strong>Pathway:</strong> {task.pathway}</span>
              <span><strong>Barrier:</strong> {task.barrier && task.barrier.alt_web_friendly_barrier}</span>
              <span><strong>BCT:</strong> {task.bct && task.bct.name}</span>
            </div>
            <div className="actions">
              <a onClick={() => { this.setState({ isEdit: true }); }} className="edit">Edit</a>
              <a onClick={() => { this.delete(task.id); }} className="delete">Delete</a>
            </div>
          </div>
        </div>
      </li>
    );
  }
}

Task.propTypes = {
  dispatch: PropTypes.func.isRequired,
  task: PropTypes.object.isRequired,
};

export default connect(state => ({
}), dispatch => ({ dispatch }))(Task);



// WEBPACK FOOTER //
// ./src/Components/Dashboard/Pages/Task/Task.jsx